import { render, staticRenderFns } from "./InputWeightPrevious.vue?vue&type=template&id=190ec62e&"
import script from "./InputWeightPrevious.vue?vue&type=script&lang=js&"
export * from "./InputWeightPrevious.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports